import { getApp } from "firebase/app";
import { getRefs } from "../ref";
import { getAuth } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";

const app = getApp();
const auth = getAuth(app);

const { TYPES } = require("./life.type");
// :::::::::: firebase :::::::::::://
const financeLifeSub = [];
export const snapFinanceLifeAll = (callback) => (dispatch) => {
  setFinanceLifeAllSuccess(dispatch, null);
  const cRef = getRefs().life;
  const uid = auth?.currentUser?.uid;
  const id = `reseller-${uid}`;
  const dRef = doc(cRef, id);
  const unsub = onSnapshot(dRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot?.data();
      setFinanceLifeAllSuccess(dispatch, data);
    }
  });

  financeLifeSub.push(unsub);
};

export const unSnapFinanceLifeAll = () => {
  financeLifeSub.forEach((sub) => sub());
  financeLifeSub.length = 0;
};

// :::::::::: local :::::::::::://
export const setFinanceLifeOpenWithdraw = (data) => (dispatch) => {
  setFinanceLifeOpenWithdrawSuccess(dispatch, data);
};
// :::::::::: dispatch :::::::::::://
const setFinanceLifeAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_LIFE_ALL,
    payload: data,
  });
};

const setFinanceLifeOpenWithdrawSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_LIFE_OPEN_WITHDRAW,
    payload: data,
  });
};
